var styles = {"element":"styles_element__iXz2p","fitContent":"styles_fit-content__T-iAL","noSpacing":"styles_no-spacing__tXKPL","compactSpacing":"styles_compact-spacing__IytZq","comfortableSpacing":"styles_comfortable-spacing__9J2MG","looseSpacing":"styles_loose-spacing__IKTyJ"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
